import { downloadExcavationPermitPdf, isExcavationPermit as isExcavationPermitPdf } from "../../RoadClosureWorkPermit/excavationPermitPdf";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IoSearchOutline } from "react-icons/io5";
import { TbRefresh } from "react-icons/tb";
import { IoMdArrowBack } from "react-icons/io";
import Tooltip from "@mui/material/Tooltip";
import API_URL from "../../../src/Config.js";
import Pagination from "../../../src/Component/Pagination";
import jsPDF from "jspdf";
import ReactDOM from "react-dom";
import html2canvas from "html2canvas";
import { RxDownload } from "react-icons/rx";
import ColdWorkPermitTemplate from "../../ColdWorkPermit/ColdWorkPermitTemplate.js";
import HotWorkPermitTemplate from "../../HotWorkPermit/HotWorkPermitTemplate.js";
import ConfinedSpaceTemplate from "../../ConfiedSpaceWorkPermit/ConfinedSpaceTemplate.js";

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(null, args), delay);
  };
};

function WorkPermitListView({ isSidebarExpanded }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const listType = searchParams.get("list_type") || "all";
  const departmentId = searchParams.get("department_id") || "";
  const filterOption = searchParams.get("filter_option") || "all";
  const startDate = searchParams.get("start_date") || "";
  const endDate = searchParams.get("end_date") || "";
  const permitTypeId = searchParams.get("permit_type_id") || "";

  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const [departmentName, setDepartmentName] = useState("");

  const containerRef = useRef(null);

  const formatDate = (dateString) => {
    if (!dateString) return "NA";

    const d = new Date(dateString);
    if (Number.isNaN(d.getTime())) return "Invalid date";

    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Kolkata",
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).formatToParts(d);

    const get = (type) => parts.find((p) => p.type === type)?.value || "";

    return `${get("weekday")}, ${get("day")} ${get("month")} ${get(
      "year",
    )} ${get("hour")}:${get("minute")}:${get("second")} IST`;
  };

  const fetchData = async (
    currentPage,
    currentItemsPerPage,
    searchQuery = "",
  ) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      if (!authKey) {
        console.error("No authentication key found");
        setLoading(false);
        return;
      }

      const params = {
        list_type: listType,
        filter_option: filterOption || "All",
        page: currentPage,
        per_page: currentItemsPerPage,
      };

      if (departmentId && departmentId.trim() !== "") {
        params.department_id = departmentId;
      }

      if (permitTypeId && permitTypeId.trim() !== "") {
        params.permit_type_id = permitTypeId;
      }

      if (
        startDate &&
        endDate &&
        startDate.trim() !== "" &&
        endDate.trim() !== ""
      ) {
        params.start_date = startDate;
        params.end_date = endDate;
      }

      if (searchQuery && searchQuery.trim() !== "") {
        params.query = searchQuery.trim();
      }

      console.log("Fetching Work Permit list with params:", params);

      const response = await axios.get(`${API_URL}/api/kpi/work-permit/list`, {
        headers: {
          Authorization: authKey,
          "Content-Type": "application/json",
        },
        params,
      });

      console.log("API Response:", response.data);

      setReports(response.data.items || []);
      setTotalItems(response.data.total_items || 0);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching Work Permit list:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
      }
      setLoading(false);
      setReports([]);
      setTotalItems(0);
    }
  };

  const debouncedSearch = useCallback(
    debounce((searchQuery) => {
      setPage(1);
      fetchData(1, itemsPerPage, searchQuery);
    }, 300),
    [
      itemsPerPage,
      listType,
      departmentId,
      filterOption,
      startDate,
      endDate,
      permitTypeId,
    ],
  );

  useEffect(() => {
    fetchData(page, itemsPerPage, searchInput);
  }, [
    page,
    itemsPerPage,
    listType,
    departmentId,
    filterOption,
    startDate,
    endDate,
    permitTypeId,
  ]);

  const handlePaginationChange = (currentPage, newItemsPerPage) => {
    setPage(currentPage);
    setItemsPerPage(newItemsPerPage);
  };

  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchInput(value);

    if (value.trim() === "") {
      setPage(1);
      fetchData(1, itemsPerPage, "");
    } else {
      debouncedSearch(value);
    }
  };

  const handleSortpopup = () => {
    setIsSortPopup(!isSortPopup);
  };

  const closePopups = () => {
    setIsSortPopup(false);
  };

  const handleRefresh = () => {
    setSearchInput("");
    setPage(1);
    fetchData(1, itemsPerPage, "");
  };

  const handleBack = () => {
    navigate(-1);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "issued":
      case "renewed":
      case "approved":
      case "active":
        return "#2E8B57";
      case "closed":
        return "red";
      case "rejected":
      case "inactive":
        return "#F81700";
      case "submitted":
      case "in review":
      case "pending approval":
      case "pending":
        return "#D4AC0D";
      case "safety approved":
      case "fire&safety verified":
      case "o&m verified":
        return "#17a2b8";
      default:
        return "black";
    }
  };

  const getListTypeDisplay = () => {
    switch (listType) {
      case "all":
        return "All Permits";
      case "approved":
        return "Issued Permits";
      case "pending":
        return "Pending Permits";
      case "closed":
        return "Closed Permits";
      case "rejected":
        return "Rejected Permits";
      default:
        return "Work Permits";
    }
  };

  const formatDates = (dateString) => {
    if (!dateString || typeof dateString !== "string") return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "";
      const formatter = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
      });
      return formatter.format(date);
    } catch (error) {
      return "";
    }
  };

  const handleDownloadPdf = async (formId, work_permit_name) => {
    if (isExcavationPermitPdf(work_permit_name)) {
      return downloadExcavationPermitPdf(formId, { isSidebarExpanded });
    }
    console.log("formId", formId);
    console.log("work_permit_name", work_permit_name);

    let TemplateComponent;

    switch (work_permit_name?.toLowerCase()) {
      case "cold work":
        TemplateComponent = ColdWorkPermitTemplate;
        break;
      case "hot work":
        TemplateComponent = HotWorkPermitTemplate;
        break;
      case "confined space":
        TemplateComponent = ConfinedSpaceTemplate;
        break;
      default:
        console.error("Unknown permit type:", work_permit_name);
        return;
    }

    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/get_permit_details`, {
        headers: { Authorization: authKey },
        params: { permit_id: formId },
      });

      if (response.status === 200) {
        const permitDetails = response.data;

        const tempDiv = document.createElement("div");
        document.body.appendChild(tempDiv);

        ReactDOM.render(
          <TemplateComponent
            permitDetails={permitDetails}
            isSidebarExpanded={isSidebarExpanded}
          />,
          tempDiv,
        );

        const section1 = tempDiv.querySelector("#section1");
        const section2 = tempDiv.querySelector("#section2");

        if (!section1 || !section2) {
          console.error("PDF sections not found.");
          return;
        }

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = 210;
        const pageHeight = 297;
        const margin = 5;

        const options = {
          scale: 1.8,
          useCORS: true,
          backgroundColor: "white",
          windowWidth: 1550,
        };

        const canvas1 = await html2canvas(section1, options);
        const imgData1 = canvas1.toDataURL("image/jpeg", 0.9);

        const imgWidth1 = pageWidth - margin * 2;
        const imgHeight1 = (canvas1.height * imgWidth1) / canvas1.width;
        const adjustedHeight1 =
          imgHeight1 > pageHeight - margin * 2
            ? pageHeight - margin * 2
            : imgHeight1;

        pdf.addImage(
          imgData1,
          "JPEG",
          margin,
          margin,
          imgWidth1,
          adjustedHeight1,
        );

        const canvas2 = await html2canvas(section2, options);
        const imgData2 = canvas2.toDataURL("image/jpeg", 0.9);

        const imgWidth2 = pageWidth - margin * 2;
        const imgHeight2 = (canvas2.height * imgWidth2) / canvas2.width;
        const adjustedHeight2 =
          imgHeight2 > pageHeight - margin * 2
            ? pageHeight - margin * 2
            : imgHeight2;

        pdf.addPage();
        pdf.addImage(
          imgData2,
          "JPEG",
          margin,
          margin,
          imgWidth2,
          adjustedHeight2,
        );

        const fileSafePermitName = work_permit_name.replace(/\s+/g, "_");
        const fileName = `${fileSafePermitName}_Permit_${formId}.pdf`;
        pdf.save(fileName);

        ReactDOM.unmountComponentAtNode(tempDiv);
        document.body.removeChild(tempDiv);
      } else {
        console.error("Failed to fetch permit details:", response.statusText);
      }
    } catch (error) {
      console.error("Error generating PDF:", error.message);
    }
  };

  const handleViewPermitsPdf = (permit_id, work_permit_name, wp_status) => {
    console.log("permit_idpermit_id", permit_id, work_permit_name);
    navigate(`/view-pdf-formate/${permit_id}/${work_permit_name}/${wp_status}`);
  };

  return (
    <div
      className={`data-list-content-container page-content ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="data-list-content" ref={containerRef}>
        <div className="data-list-header">
          <div className="data-list-header-content">
            <div className="data-list-heading-content-left-side">
              <span className="report-name">
                Work Permits - {getListTypeDisplay()}
              </span>

              {departmentName && (
                <span
                  className="department-show"
                  style={{
                    color: "green",
                    marginLeft: "15px",
                    fontWeight: "500",
                  }}
                >
                  {departmentName}
                </span>
              )}

              {startDate && endDate && (
                <span
                  className="option-show"
                  style={{
                    color: "#ce9139ed",
                    marginLeft: "15px",
                    fontWeight: "500",
                  }}
                >
                  {formatDates(startDate)} - {formatDates(endDate)}
                </span>
              )}
            </div>

            <div className="data-list-heading-content-right-side">
              <div className="search-bar-container">
                <input
                  type="text"
                  placeholder="Search ..."
                  value={searchInput}
                  onChange={handleSearchInputChange}
                  className="search-bar"
                />
                <IoSearchOutline className="search-bar-icon" />
              </div>

              <Tooltip title="Refresh List" arrow>
                <button className="refresh-button" onClick={handleRefresh}>
                  <TbRefresh className="refresh-icon" />
                </button>
              </Tooltip>

              <button className="sort-button" onClick={handleSortpopup}>
                <PiDotsThreeOutlineVerticalFill className="sort-icon" />
              </button>

              {isSortPopup && (
                <div className="sort-popup-container">
                  <div className="sort-popup-content">
                    <div className="sort-by">SORT BY</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="data-list-body" onClick={closePopups}>
          <div className="data-list-scroll-body">
            <div className="data-list-table">
              {loading ? (
                <div className="loader-container">
                  <div className="loader"></div>
                  <div>Loading...</div>
                </div>
              ) : reports.length > 0 ? (
                <table className="table multilevel-data">
                  <thead>
                    <tr>
                      <th className="center-alignment">SR. NO.</th>
                      <th>SERIAL NUMBER</th>
                      <th>REQUEST ID</th>
                      <th>DEPARTMENT</th>
                      <th>PERMIT TYPE</th>
                      <th>RECEIVER NAME</th>
                      <th>SECTION</th>
                      <th>WORK DESCRIPTION</th>
                      <th className="center-alignment">REQUEST STATUS</th>
                      <th className="center-alignment">STATUS</th>
                      <th>ISSUED DATE</th>
                      <th>CLOSED DATE</th>
                      <th>CREATED DATE</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody className="data-list-scroll-bodys">
                    {reports.map((report, index) => (
                      <tr key={report.id} className="hoverable-row">
                        <td className="center-alignment">
                          {(page - 1) * itemsPerPage + index + 1}
                        </td>
                        <td>{report.serial_number || "NA"}</td>
                        <td>{report.request_id || "NA"}</td>
                        <td>{report.department_name || "NA"}</td>
                        <td>{report.permit_type_name || "NA"}</td>
                        <td>{report.receiver_name || "NA"}</td>
                        <td>{report.section || "NA"}</td>
                        <td>{report.facility_location || "NA"}</td>
                        <td>
                          <div
                            className="status-schedules"
                            style={{
                              backgroundColor: getStatusColor(
                                report.request_status,
                              ),
                              width: "8vw",
                              fontSize: "11px",
                              color: "white",
                              padding: "5px 1px",
                              borderRadius: "30px",
                            }}
                          >
                            {report.request_status
                              ? report.request_status.charAt(0).toUpperCase() +
                                report.request_status.slice(1).toLowerCase()
                              : "NA"}
                          </div>
                        </td>
                        <td>
                          <div
                            style={{
                              color: getStatusColor(report.status),
                              width: "8vw",
                              fontSize: "13px",
                              padding: "5px 1px",
                              borderRadius: "30px",
                              textAlign: "center",
                              fontWeight: 500,
                            }}
                          >
                            {report.status
                              ? report.status.charAt(0).toUpperCase() +
                                report.status.slice(1).toLowerCase()
                              : "NA"}
                          </div>
                        </td>
                        <td>{formatDate(report.issued_date)}</td>
                        <td>{formatDate(report.closed_at)}</td>
                        <td>{formatDate(report.created_at)}</td>
                        <td>
                          <button
                            className="new-button-download"
                            onClick={() =>
                              handleViewPermitsPdf(
                                report?.id,
                                report?.permit_type_name,
                                "wp_requester",
                              )
                            }
                          >
                            View PDF
                          </button>
                          {/* {["issued", "closed"].includes(
                            report.request_status?.toLowerCase(),
                          ) && (
                            <button
                              className="new-button-download"
                              onClick={() =>
                                handleDownloadPdf(
                                  report.id,
                                  report.permit_type_name,
                                )
                              }
                            >
                              <RxDownload className="dnld-btn" />
                            </button>
                          )} */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="no-users-container">
                  <div className="no-users-message">
                    No {getListTypeDisplay()} Records Found
                  </div>
                </div>
              )}
            </div>

            {totalItems > 0 && (
              <Pagination
                showPerPage={itemsPerPage}
                total={totalItems}
                onPaginationChange={handlePaginationChange}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkPermitListView;
